// should-toggle.ts — PSTUDIO-3624
export interface ToggleKeyState {
  key: string;
  shiftKey: boolean;
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
}
export interface ToggleCtx {
  isEditing: boolean;
  isInInput: boolean;
}
// PSTUDIO-3624: Shift+Enter toggles the Expanded Cell View panel. It is a plain
// panel-toggle shortcut — it fires regardless of how many cells are selected
// (0, 1, or many), so the panel can be opened with nothing selected (it then
// shows the empty state). The only guards are:
//   - `!isEditing` — an in-cell edit keeps Shift+Enter = commit + move up;
//   - `!isInInput` — focus inside an input/textarea (incl. the panel's own
//     textarea) keeps Shift+Enter = move up, so typing is never hijacked.
export function shouldToggleExpandedCellView(
  e: ToggleKeyState,
  ctx: ToggleCtx
): boolean {
  return (
    e.key === 'Enter' &&
    e.shiftKey &&
    !e.metaKey &&
    !e.ctrlKey &&
    !e.altKey &&
    !ctx.isEditing &&
    !ctx.isInInput
  );
}
